import classNames from 'classnames';
import {Typography} from 'components/Typography';
import {MOCK_CATEGORIES} from 'core/constants';
import style from './style.module.scss';
import React, {FC} from 'react';
import Link from 'components/CustomRoutingLink';

interface INavigationItemProps {
    code?: string;
    name: string;
    href: string;
    isMarked?: boolean;
}

const NavigationItem: FC<INavigationItemProps> = ({code, name, href, isMarked}) => {
    const isSale = 'sale' === code;

    return (
        // TODO: из-за текущей реализации фильтров каталог не работает корректно при использовании NextLink
        <li className={classNames(style.navItem, {[style.sale]: isSale})} role={'tab'}>
            <Link href={href || '/'} className={style.link}>
                <Typography variant={'p-custom-16'}>{name}</Typography>
            </Link>
            {isMarked && <span className={classNames('mark', style.mark)} />}
        </li>
    );
};

export const NavigationList: FC = () => {
    return (
        <>
            {MOCK_CATEGORIES.map((category, index) => (
                <NavigationItem key={index} {...category} />
            ))}
        </>
    );
};
